var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5976 4.28876C12.4527 4.10295 12.2321 3.99638 12.0002 4.00009C11.7683 4.00381 11.5511 4.1174 11.4119 4.30776L8.6369 8.1034H7.0119C6.59769 8.1034 6.2619 8.44787 6.2619 8.87279C6.2619 9.29771 6.59769 9.64217 7.0119 9.64217H9.0119C9.24797 9.64217 9.47026 9.52816 9.61191 9.33442L12.031 6.02554L15.4263 10.3793C15.5757 10.5709 15.8054 10.6779 16.0444 10.6673C16.2835 10.6567 16.5032 10.5296 16.6359 10.3254L18.4133 7.59047H21.0119C21.4261 7.59047 21.7619 7.24601 21.7619 6.82109C21.7619 6.39617 21.4261 6.0517 21.0119 6.0517H18.0119C17.7611 6.0517 17.527 6.18027 17.3879 6.39431L15.9568 8.59637L12.5976 4.28876Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37549 21.4712C11.9057 22.2248 14.6039 22.1729 17.111 21.3156L20.8897 20.0235C21.5528 19.7968 22 19.1602 22 18.4432C22 17.3596 21.0073 16.5644 19.9824 16.8273L17.6228 17.4324L15.2563 18.3152C14.867 18.4604 14.4367 18.2544 14.2952 17.8551C14.1536 17.4557 14.3544 17.0143 14.7437 16.8691L17.1179 15.9834C16.8929 15.2946 16.317 14.7398 15.549 14.6085L14.9795 14.5111C13.1183 14.1929 11.2132 14.2943 9.39619 14.8067C9.46373 15.0392 9.5 15.2855 9.5 15.5404V20.6697C9.5 20.9496 9.45629 21.219 9.37549 21.4712Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.5404C2 14.9739 2.44772 14.5146 3 14.5146H7C7.55228 14.5146 8 14.9739 8 15.5404V20.6697C8 21.2362 7.55228 21.6955 7 21.6955H3C2.44772 21.6955 2 21.2362 2 20.6697V15.5404Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMedical);
export default __webpack_public_path__ + "static/media/share-medical.7969003ee0404af2995c8c9c433d47db.svg";
export { ForwardRef as ReactComponent };